import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.9 62.51" width="1em" height="1em">
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path fill="fj-icons-primary-color" d="M.76 28.73l30.4 17.54 29.99-17.54H.76z" />
        <path
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.51}
          d="M.76 28.73L30.95 1.76l30.2 26.97"
        />
        <path
          d="M12.18.75h37.44A2.42 2.42 0 0152 3.17v48.19h0H9.76h0V3.17A2.42 2.42 0 0112.18.75z"
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.51}
        />
        <path
          d="M31.16 46.27L.75 28.73v30.54a2.5 2.5 0 002.49 2.49h55.42a2.5 2.5 0 002.49-2.49V28.73z"
          fill="fj-icons-bg-color"
          stroke="fj-icons-primary-color"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.51}
        />
        <path fill="#90c7b1" d="M41.15 11.16v-4.4l-20 6.52 3.82 2.49 16.18-4.61z" />
        <path fill="#2dc3e9" d="M41.15 16.59v-4.4L25.96 16.4l3.81 2.51 11.38-2.32z" />
        <path fill="#0c6876" d="M41.15 17.73v4.4l-6.61-.11-3.79-2.45 10.4-1.84z" />
        <path fill="#90c7b1" d="M41.15 27.42l-20-13.01v3.47l20 10.79v-1.25z" />
        <path fill="#2dc3e9" d="M41.15 29.98l-20-10.87v3.48l20 8.64v-1.25z" />
        <path fill="#0c6876" d="M41.15 33.65l-20-6.38v-3.51l20 8.63v1.26z" />
      </g>
    </g>
  </svg>
);

const Invites = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default Invites;
